import type { CityConfig } from "../city-template/types";

export const goshenConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Goshen",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "goshen",
  route: "/goshen",
  title: "Emergency Passport Goshen, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Goshen, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Goshen, Elkhart, Nappanee, Bristol, Middlebury, and all Elkhart County residents. A+ BBB rated registered courier serving RV capital travelers and Goshen College families.",
  h1: "Emergency & Expedited Passport Services in Goshen, IN",
  heroSubtitle: "Goshen travelers — from RV industry executives heading to international trade shows to Goshen College students studying abroad to Elkhart County families planning vacations — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier with direct access to the Chicago Passport Agency, just over 2 hours west.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Goshen%20Indiana%20historic%20downtown%20Main%20Street%20with%20iconic%20old%20courthouse%20and%20tree%20lined%20streets%2C%20charming%20small%20Midwestern%20city%20with%20vibrant%20storefronts%2C%20Elkhart%20County%20countryside%20with%20Amish%20farmland%20and%20horse%20drawn%20buggies%20in%20the%20distance%2C%20warm%20golden%20afternoon%20sunlight%2C%20professional%20small%20town%20photography%20with%20rich%20warm%20tones%2C%20classic%20heartland%20Americana%20charm%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography&width=1800&height=700&seq=goshen-in-hero-001&orientation=landscape",
  heroImageAlt: "Goshen Indiana historic downtown with Elkhart County courthouse and tree-lined Main Street",
  geoPosition: "41.5892;-85.8344",
  geoPlacename: "Goshen, Indiana",
  lastModified: "2026-06-08",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 W Ida B Wells Dr, Chicago, IL 60605",
    distance: "Approximately 2 hours and 15 minutes west of Goshen via US-20 and I-94 — about 110 miles",
  },
  nearbyCitiesZips: [
    { name: "Goshen", zips: "46526, 46527, 46528" },
    { name: "Elkhart", zips: "46514, 46516, 46517" },
    { name: "Nappanee", zips: "46550" },
    { name: "Bristol", zips: "46507" },
    { name: "Middlebury", zips: "46540" },
    { name: "Wakarusa", zips: "46573" },
    { name: "Millersburg", zips: "46543" },
    { name: "New Paris", zips: "46553" },
    { name: "Syracuse", zips: "46567" },
    { name: "Dunlap", zips: "46517" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Chicago Passport Agency — about 2 hours from Goshen via US-20" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Elkhart County" },
    { icon: "ri-building-line", title: "RV Industry Hub", desc: "Serving Goshen's manufacturing executives, international trade show travelers, and Goshen College community" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx in Goshen or nearby Elkhart" },
  ],
  internalLinks: [
    { name: "Expedited passport in Elkhart, IN", route: "/elkhart" },
    { name: "Emergency passport help in South Bend, IN", route: "/south-bend" },
    { name: "Urgent passport services in Fort Wayne, IN", route: "/fort-wayne" },
    { name: "Indiana passport services overview", route: "/indiana" },
  ],
  fpcOfficeAddress: "101 W Ida B Wells Dr, Chicago, IL 60605",
  fpcOfficeNote: "Fast Passport Center serves Goshen, Indiana via secure registered courier to the Chicago Passport Agency. Approximately 110 miles — about 2 hours and 15 minutes via US-20 and I-94. We handle the Chicago drive so Goshen residents, RV industry travelers, and Elkhart County families never need to navigate Chicago traffic.",
  fpcOfficeDistance: "Serving Goshen, Elkhart, Nappanee, Bristol, Middlebury, Wakarusa, Syracuse, and all of Elkhart County and the surrounding northern Indiana region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Goshen and Elkhart County. From the historic downtown courthouse square and Goshen College to RV manufacturing facilities and nearby communities — we serve all of Elkhart County and northern Indiana.",
  nearbyCitiesIntro: "We serve Goshen and all nearby communities including Elkhart, Nappanee, Bristol, Middlebury, Wakarusa, Millersburg, and Syracuse. We also serve all of Elkhart County and the Goshen College community.",
  howItWorksIntro: "Most Goshen travelers — especially RV manufacturing executives heading to European trade shows and Goshen College students preparing for study abroad — complete everything online and ship documents via overnight courier from any UPS or FedEx location. Our registered couriers handle the Chicago Passport Agency delivery.",
  mistakesIntro: "Goshen is a tight-knit community with a surprising amount of international travel — from the RV industry's global trade shows to Goshen College's renowned study abroad programs. Here are the most common passport mistakes we see from Elkhart County travelers.",
  testimonialsIntro: "Goshen travelers — from RV executives heading to Düsseldorf to Goshen College students preparing for semesters abroad — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Goshen, IN? Here are the most common ones we hear from Elkhart County travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Chicago drive required — ship from Goshen or Elkhart", "Perfect for RV trade shows in Europe, Goshen College study abroad, and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Chicago Passport Agency (~2+ hours each way)", "Limited appointments for non-emergency travelers"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Goshen travelers with immediate departure needs — as fast as 24 hours. Ideal for RV manufacturing executives with last-minute European trade show travel or Goshen College students with urgent study abroad deadlines.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency — courier handles the 2+ hour drive", "RV industry and college travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Goshen adults with a passport issued within the last 15 years. Skip the post office appointment — ideal for Elkhart County professionals and families.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Goshen address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Goshen residents, Goshen College students, and Elkhart County families.",
      bullets: ["Acceptance facility scheduling in Goshen or Elkhart", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Goshen and Elkhart County residents — whether lost during travel, misplaced at home, or stolen while preparing for a trip.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Goshen and Elkhart County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Goshen and Elkhart County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Goshen IN", description: "Urgent passport processing for Goshen Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Goshen IN", description: "Fast passport renewal for Goshen Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Goshen IN", description: "New passport application services for Goshen Indiana residents and Goshen College students." },
    { name: "Child Passport Goshen IN", description: "Minor passport services for Goshen Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Mark H.",
      location: "Goshen, IN — RV Industry Executive",
      rating: 5,
      text: "We had a major trade show in Düsseldorf and I realized my passport had expired during COVID. Fast Passport Center got me renewed in 4 days. Shipped from the UPS Store in Goshen and everything was seamless. Made my flight out of Chicago without a hitch.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Rebecca S.",
      location: "Goshen, IN — Goshen College",
      rating: 5,
      text: "My daughter was heading to a semester in Costa Rica through Goshen College's SST program and we discovered her passport was expired two weeks before departure. Fast Passport Center expedited everything and her new passport arrived in 5 days. Absolute relief for our family.",
      service: "Student Passport Renewal",
    },
    {
      name: "Daniel & Miriam Y.",
      location: "Middlebury, IN — Near Goshen",
      rating: 5,
      text: "Family trip to visit relatives in Switzerland and we needed first-time passports for our three kids. The Goshen Post Office was booking weeks out for appointments. Fast Passport Center walked us through everything and all five passports arrived together in 6 days. Truly outstanding service.",
      service: "Family Passport Bundle",
    },
    {
      name: "Carlos R.",
      location: "Goshen, IN — Manufacturing Supervisor",
      rating: 5,
      text: "Got called to a supplier meeting in Monterrey, Mexico with 8 days notice. My passport had less than 2 months validity remaining. Fast Passport Center renewed it in 3 days and I made my flight. The whole process was smooth and professional.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "goshen-in-1",
      name: "Goshen Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "415 W Pike St",
      city: "Goshen",
      state: "IN",
      zip: "46526",
      phone: "(574) 533-4811",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Goshen, near the Elkhart County Courthouse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Goshen acceptance facility. Appointments required — book 2–3 weeks ahead during peak travel seasons. Convenient for Goshen College students and Elkhart County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "goshen-in-2",
      name: "Elkhart Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "601 S Main St",
      city: "Elkhart",
      state: "IN",
      zip: "46516",
      phone: "(574) 294-5521",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 10 miles west of Goshen, in downtown Elkhart",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with more appointment slots than Goshen. Often has better availability during peak RV trade show travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "goshen-in-3",
      name: "Elkhart County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "101 N Main St",
      city: "Goshen",
      state: "IN",
      zip: "46526",
      phone: "(574) 535-6469",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Downtown Goshen, Elkhart County Courthouse",
      website: "https://www.elkhartcounty.com/",
      websiteLabel: "Elkhart County",
      notes: "County clerk passport acceptance. Extended morning hours. Good alternative when post office appointments are full, especially during Goshen College SST program enrollment periods.",
      icon: "ri-government-line",
    },
    {
      id: "goshen-in-4",
      name: "Nappanee Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 E Market St",
      city: "Nappanee",
      state: "IN",
      zip: "46550",
      phone: "(574) 773-2122",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 10 miles southwest of Goshen, in Nappanee",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Smaller facility serving southwestern Elkhart County. Good option for Nappanee and Wakarusa area residents. Call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "goshen-in-5",
      name: "Bristol Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "104 E Elkhart St",
      city: "Bristol",
      state: "IN",
      zip: "46507",
      phone: "(574) 848-4417",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 8 miles north of Goshen, in Bristol",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative acceptance facility north of Goshen. Convenient for Middlebury and Bristol area residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2+ hour drive to Chicago via I-94", fpc: "No — ship from Goshen, courier handles it" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "RV Trade Show Travel", agency: "No special support for business travelers", fpc: "Experienced with RV industry international trade deadlines" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until Trade Show Season",
      description: "Goshen's RV industry sends executives to major European trade shows like the Caravan Salon in Düsseldorf each year. These events have fixed dates, yet many travelers wait until weeks before to check their passport. Routine processing takes 8–11 weeks — well beyond most trade show planning windows.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Passport photos from local drugstores sometimes fail State Department standards. Photos must be exactly 2x2 inches on a white background — no filters, no glasses, neutral expression. Always confirm compliance before leaving the photo location.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "First-time applicants in Goshen — especially Goshen College students applying for their first passport for SST programs — often miss signatures or use the wrong form. DS-11 requires in-person execution at an acceptance facility.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Accounting for Goshen College SST Deadlines",
      description: "Goshen College's Study-Service Term (SST) sends students abroad each year with fixed departure dates. Passport processing during peak SST enrollment (October–November and March–April) sees heavy demand at the Goshen Post Office. Book acceptance appointments early.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries — especially in Europe and Asia — require 6 months of passport validity beyond your stay. RV executives heading to European trade shows or family members visiting relatives abroad often discover this requirement too late.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Assuming Chicago Agency Is Close Enough for Walk-Ins",
      description: "The Chicago Passport Agency requires appointments booked through NPIC — no walk-ins. Even though it's about 2 hours away, you cannot simply show up. And appointments are not guaranteed, especially during peak travel seasons.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Goshen or Elkhart County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS Store or FedEx in Goshen or Elkhart." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Elkhart County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier delivers to the Chicago Passport Agency — no need to make the 2+ hour drive." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Goshen address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Goshen, IN?", a: "Fast Passport Center offers emergency passport processing in Goshen, Indiana in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency — no need to make the 2+ hour drive yourself." },
    { q: "Does Goshen have its own passport agency?", a: "No — Goshen does not have a regional passport agency. The nearest is the Chicago Passport Agency, approximately 110 miles west (about 2 hours and 15 minutes via US-20 and I-94). Fast Passport Center's courier service means Goshen residents never need to navigate Chicago traffic themselves." },
    { q: "Can RV industry travelers get expedited passports for European trade shows?", a: "Absolutely. Goshen is the RV capital of the world and we regularly serve manufacturing executives heading to major trade shows like the Caravan Salon in Düsseldorf and other European industry events. We understand the fixed-date, non-negotiable nature of these events and can coordinate expedited processing to match your flight schedule." },
    { q: "What about Goshen College SST program students?", a: "Yes — we serve all Goshen College students preparing for Study-Service Term (SST) programs abroad. We understand the SST timeline and can help students who discover passport issues close to their departure date. Expedited processing available for confirmed travel." },
    { q: "What airport do Goshen travelers use?", a: "South Bend International Airport (SBN) is about 35 miles west of Goshen — approximately 40 minutes via US-20. For international flights, Chicago O'Hare (ORD) is about 125 miles west — approximately 2 hours and 15 minutes. Most Goshen international travelers connect through ORD or fly from SBN to a major hub." },
    { q: "How much does an expedited passport cost in Goshen, IN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Goshen?", a: "Walgreens (4024 Elkhart Rd), CVS (209 Chicago Ave), and the UPS Store (multiple locations in Goshen and Elkhart) all offer passport photo services. Photos must be 2x2 inches on a white background, taken within 6 months, with a neutral expression and no glasses." },
    { q: "Does Fast Passport Center serve Middlebury, Bristol, or Nappanee residents?", a: "Absolutely. Fast Passport Center serves all of Elkhart County including Middlebury, Bristol, Nappanee, Wakarusa, Millersburg, New Paris, and Syracuse. Our courier service works the same way for everyone throughout northern Indiana." },
  ],
  photoLocations: [
    { name: "Walgreens — Goshen (Elkhart Rd)", address: "4024 Elkhart Rd, Goshen, IN 46526", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS — Goshen (Chicago Ave)", address: "209 Chicago Ave, Goshen, IN 46526", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Goshen", address: "3938 Midway Rd, Goshen, IN 46526", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Elkhart (Nappanee St)", address: "1545 Nappanee St, Elkhart, IN 46514", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Goshen", address: "2018 Lincolnway E, Goshen, IN 46526", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended. Convenient east side location near US-33.", featured: true },
    { name: "Indiana BMV — Elkhart", address: "1209 N Nappanee St, Elkhart, IN 46514", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Serves Elkhart and northern Elkhart County. Alternative when Goshen BMV appointments are full. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "SBN",
      name: "South Bend International Airport",
      distance: "35 miles west of Goshen via US-20 — approximately 40 minutes",
      address: "4477 Progress Dr, South Bend, IN 46628",
      note: "Nearest commercial airport to Goshen. Domestic connections to major hubs including Atlanta, Charlotte, Chicago, Detroit, and Minneapolis. Convenient for domestic connections before international travel.",
      flightUrl: "https://flysbn.com/",
      flightLabel: "SBN Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "125 miles west of Goshen via I-94 — approximately 2 hours and 15 minutes",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international gateway serving Goshen and northern Indiana. Direct flights to Europe, Asia, and Latin America. The primary hub for Goshen RV industry international travelers.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { label: "Elkhart County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Elkhart County and all Indiana counties" },
    { label: "Elkhart County Clerk: Marriage Licenses", url: "https://www.elkhartcounty.com/", icon: "ri-heart-line", description: "Elkhart County Clerk — marriage license records for Goshen and Elkhart County" },
    { label: "Elkhart County: Divorce Decrees", url: "https://www.elkhartcounty.com/", icon: "ri-file-list-3-line", description: "Elkhart County Clerk of Courts — divorce decree records for Goshen and Elkhart County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Goshen address" },
  ],
};